<template>
  <ion-thumbnail>
    <img
      :alt="organisation.name"
      :src="config.appicon"
    >
  </ion-thumbnail>
</template>

<script>
import { defineComponent } from 'vue';
import { IonThumbnail } from '@ionic/vue';
import store from '@/store';

export default defineComponent({
  components: {
    IonThumbnail,
  },
  computed: {
    config: () => store.config,
    organisation: () => store.organisation,
  },
});
</script>
